import React, { useState, useEffect, useMemo, memo } from 'react';
import PDPGallery from "./PDPGallery";
import PropertyTags from "./PropertyTags";
import { useSelector, useDispatch } from "react-redux";
// import { FontAwesomeIcon } from 'fortawesome/react-fontawesome'
// import { FaFontAwesome } from "react-icons/fa";
import { FiMapPin } from "react-icons/fi";

import { RiGalleryView2 } from "react-icons/ri";
import Carousel from 'react-bootstrap/Carousel';
import ImageSingle from '@/components/srp/CardComponents/ImageSingle';
import '/src/components/pdp/style/pdp.css'
import { setDefaults, fromAddress } from "react-geocode";
import { Modal, Button, Row, Col } from "react-bootstrap";
import GalleryBidCenter from './GalleryBidCenter';
import { FaHeart } from "react-icons/fa";
import { IoShareSocialOutline } from "react-icons/io5";
import { GoogleMap, useLoadScript, LoadScript, Marker } from '@react-google-maps/api';
import ReactStreetview from "react-streetview";
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { TbLocation } from "react-icons/tb";
import moreImagesOnTheWay from '../../../../public/assets/images/more-images-rectangle-2x.png';
import moreImagesOnTheWaySquare from '../../../../public/assets/images/more-images-square-2x.png';

import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
  PinterestIcon,
} from "react-share";
import { FaInstagram } from 'react-icons/fa';
import save from '../../../../public/assets/images/pdp/save.svg';
import saved from '../../../../public/assets/images/pdp/saved.svg';
import shareImg from '../../../../public/assets/images/pdp/share.png';
import { setIsAddedToSaved, showSavedTooltip } from '@/redux/savedpreference/savedPreferenceSlice';
import { onSavePress, onUnsavePress } from '@/api/srpFilter';
import { updateSaveProperty } from '@/redux/PDP/pdpSlice';
import PDPSaveModal from './PDPSaveModal';
import { setPropertyToSaveFrom } from '@/redux/login/loginSlice';
import GalleryStreetView from './GalleryStreetView';
import { IoEyeOutline } from "react-icons/io5";
import VideoVirtualTour from './VideoVirtualTour';
import galleryIcon from '/assets/images/pdp/galleryIcon.svg';
import streetIcon from '/assets/images/pdp/streetIcon.svg';
import { trackApiCall, trackButtonClick } from '@/utils/analytics';
import BidAlertTextModal from '../BidCenter/BidAlertTextModal';

const containerStyle = {
  width: "100%",
  height: "100%",
  marginTop: 6
};
const GalleryHeader = ({
  cmsData,
  isForeclosure,
  pdpGlobalCmsData,
  statusPayload,
  navigation,
  pdpBidCenter,
  pdpData,
  financialType,
  listingType,
  status,
  offerType,
  offerCenterDetail,
  isSignedUser,
  isFcOnlineFlag,
  pdpPropertyFees,
  isWatchProperty,
  cmsKeyInfographic,
}) => {

  const pdpInitData = useSelector((state) => state.pdp.pdpInitData);
  const [selectedCTA, setSelectedCTA] = useState("GALLERY");
  const [selectedImgIndex, setSelectedImgIndex] = useState(1);
  const [show, setShow] = useState();
  const user_info = useSelector((state) => state?.user?.user);
  const [galleryIndex, setGalleryIndex] = useState(1);
  const gmapKey = cmsData?.pdpMapsConfig?.googleMapApiKey;
  const { streetNumber, streetName, city, state, zip } = pdpInitData?.propertyDetails?.address;
  const fullAddress = `${streetNumber} ${streetName}, ${city}, ${state} ${zip}`;
  // in ui we need city state and zip on seperate line
  const fullAddressForm = `${streetNumber} ${streetName}
  ${city}, ${state} ${zip}
  `
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: cmsData?.pdpMapsConfig?.googleMapApiKey,
  });
  setDefaults({
    key: cmsData?.pdpMapsConfig?.googleMapApiKey, // Your API key here.
    language: "en", // Default language for responses.
    region: "es", // Default region for responses.
  });
  const userEmailId = useSelector((state) => state.user?.user?.userEmailId);
  const { propertyToSaveFrom, isUserSubscribed } = useSelector((state) => state.login);
  const dispatch = useDispatch();
  const [savePropertyState, setSavePropertyState] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const address = pdpInitData?.propertyDetails?.address;
  const emailBody = `Hi,

  I found this property you might be interested in on Hubzu.com`;

  const center = useMemo(
    () => ({ lat: 38.7946, lng: -106.5348 }),
    []
  );

  const isMobile = window.screen.width < 1200

  const updatedImageList = pdpInitData?.propertyDetails.imageDetails.slice(1);


  const ImagesArr = () => {
    var imgArr = [];
    pdpInitData?.propertyDetails.imageDetails.map((val, index) => {
      const img = {
        largeURL: val.pdpBigImage.startsWith('http') ? val.pdpBigImage : 'https:' + val.pdpBigImage,
        thumbnailURL: val.thumbnailUrl.startsWith('http') ? val.thumbnailUrl : 'https:' + val.thumbnailUrl,
      };
      imgArr.push(img);
    });
    return imgArr;
  };

  const updatedImageArr = () => {
    var imgArr = [];
    updatedImageList.map((val, index) => {
      const img = {
        largeURL: val.pdpBigImage.startsWith('http') ? val.pdpBigImage : 'https:' + val.pdpBigImage,
        thumbnailURL: val.thumbnailUrl.startsWith('http') ? val.thumbnailUrl : 'https:' + val.thumbnailUrl,
      };
      imgArr.push(img);
    });
    return imgArr;
  };

  const gridArr = () => {
    var imgArrNew = [];
    updatedImageList.map((val, index) => {
      const img = {
        largeURL: val.pdpBigImage.startsWith('http') ? val.pdpBigImage : 'https:' + val.pdpBigImage,
        thumbnailURL: val.thumbnailUrl.startsWith('http') ? val.thumbnailUrl : 'https:' + val.thumbnailUrl,
      };

      if (index < 4) {
        imgArrNew.push(img);
      }
    });

    if (imgArrNew?.length !== 1 && imgArrNew?.length < 4) {
      const blankImg = {
        largeURL: imgArrNew?.length === 2 ? moreImagesOnTheWay : moreImagesOnTheWaySquare,
        thumbnailURL: imgArrNew?.length === 2 ? moreImagesOnTheWay : moreImagesOnTheWaySquare,
      };
      imgArrNew?.push(blankImg);
    }

    return imgArrNew;
  };

  const handleSelect = (selectedIndex) => {
    const index = parseInt(selectedIndex) + 1;
    setSelectedImgIndex(index);
  };

  const handleClose = () => {
    setShow(false);
    if (savePropertyState) {
      dispatch(updateSaveProperty("Y"))
    } else {
      dispatch(updateSaveProperty("N"))
    }

    trackButtonClick({
      eventName: "gallery_lightbox_closed",
      eventCategory: "NEW-PDP",
      eventSource: "on image click open lightbox modal",
      eventLabel: `propId: ${pdpInitData?.propertyDetails?.propertyId}`,
    });
  };
  useEffect(() => {
    if (pdpInitData?.propertySpecialDetails?.onWatchList === "Y") {
      setSavePropertyState(true)
    } else {
      setSavePropertyState(false)
    }
  }, [pdpInitData?.propertySpecialDetails?.onWatchList])

  useEffect(() => {
    getLatLngCoordinates();
  }, [pdpInitData.propertyDetails.address.latitude, pdpInitData.propertyDetails.address.longitude])

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleFavoriteToggle = () => {

  }

  const streetViewPanoramaOptions = {
    position: { lat: pdpInitData.propertyDetails.address.latitude, lng: pdpInitData.propertyDetails.address.longitude },
    pov: { heading: 100, pitch: 0 },
    zoom: 1
  };


  const renderGallery = () => {
    const images = ImagesArr();
    return (
      <div className="pswp-gallery" id={"my-test-gallery"}>
        {images?.length > 0 ? (
          <>
          <div className="d-none d-lg-block">
          <ImageSingle className="galleryImg" onClick={renderGalleryPopUp} imageUrl={images[0]?.largeURL} style={{ backgroundSize: 'cover', height: `${screenWidth > 1600 ? 620 : 450}px`, width: '100%', borderRadius: 10, minHeight: '300px', maxHeight: '80vh' }} isPDP={true} />
          </div>
          <div className="d-block d-lg-none">
           <Carousel controls={true} slide={false} indicators={false} interval={null} onSelect={handleSelect}
             onClick={(e) => e.stopPropagation()}>
             {images.map((imgItem, index) => {
              return (
                <Carousel.Item key={`PDP-gallery-${index}-${imgItem?.largeURL}`}>
                  <ImageSingle className="galleryImg" onClick={renderGalleryPopUp} imageUrl={imgItem?.largeURL} style={{ backgroundSize: 'cover', height: '100%', width: '100%', borderRadius: 10 }} isPDP={true}  />
                 </Carousel.Item>)
             })}
           </Carousel>

          </div>

        </>
        ) : (
          <ImageSingle className="galleryImg" onClick={renderGalleryPopUp} imageUrl={images} style={{ backgroundSize: 'cover', height: `${screenWidth > 1600 ? 620 : 450}px`, width: '100%', borderRadius: 10 }} isPDP={true}  />
        )}
      </div>
    )
  }

  const renderGalleryPopUp = () => {
    setShow(true);
     trackButtonClick({
        eventName: "gallery_lightbox_opened",
        eventCategory: "NEW-PDP",
        eventSource: "on image click open lightbox modal",
        eventLabel: `propId: ${pdpInitData?.propertyDetails?.propertyId}`,
     });
  }
  const containerStyle = {
    width: '100%',
    height: '100%',
    borderRadius: '10px',
  };

  const [coordinates, setCoordinates] = useState(null);
  const [isCoordLoaded, setIsCoordLoaded] = useState(false);
  const [error, setError] = useState(null);

  // if (error) return <p>{error}</p>;
  // if (!coordinates) return <p>Loading map...</p>;


  const getLatLngCoordinates = async () => {
    let coordinates = { lat: pdpInitData?.propertyDetails?.address?.latitude, lng: pdpInitData?.propertyDetails?.address?.longitude };
    if (coordinates?.lat && coordinates?.lng) {
      setCoordinates(coordinates);
      setIsCoordLoaded(true);
    } else {
      if (fullAddress) {
        fromAddress(fullAddress)
        .then(({ results }) => {
          const { lat, lng } = results[0].geometry.location;
          setCoordinates({lat, lng});
          setIsCoordLoaded(true);
        })
        .catch((e) => {
          setError('Failed to fetch coordinates');
          setIsCoordLoaded(true);
          console.log(e);
        });
      }
    }
  }

  const renderMapView = () => {
    if (!isLoaded || !isCoordLoaded) {
      return (
        <>
          <img
            style={{ height: '100%', width: '100%', position: 'absolute', zIndex: 1, borderRadius: 10 }}
            src={"/assets/images/srp/map_placeholder.png"}
          />
          <button type="button" className="map-loader-btn">
            <div className="street-view-loader"></div>
            <div className="street-view-loader-text">{!isLoaded ? 'Loading...' : 'Retrieving properties'}</div>
          </button>
        </>
      );
    } else if (!coordinates || !coordinates?.lat || !coordinates?.lng) {
      return (
        <>
          <div className='street-error-container'>
            <b>{error ? `${error} for Map View.` : 'Map View is not available for this property.'}</b>
          </div>
        </>
      );
    }
    return (
      <div className='custom-pdp-map' style={{ width: '100%', height: '100%' }}>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={coordinates}
          zoom={15}
          options={{
            zoomControl: false,
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
          }}
          onLoad={() => console.log('Map loaded')}
        >
          <Marker
            position={coordinates}
            icon={{
              url: "/assets/images/pdp/pin.png",
              scaledSize: new window.google.maps.Size(30, 38),
            }}
          />
        </GoogleMap>
      </div>
    );
  }

  const renderGalleryView = () => {
    if (!isLoaded || !isCoordLoaded) {
      return (
        <>
          <div className='street-loader-container'>
            <div className="street-view-loader"></div>
            <div className="street-view-loader-text">{!isLoaded ? 'Loading...' : 'Retrieving properties'}</div>
          </div>
        </>
      );
    } else if (!coordinates || !coordinates?.lat || !coordinates?.lng) {
      return (
        <>
          <div className='street-error-container'>
            <b>{error ? `${error} for Street View.` : 'Street View is not available for this property.'}</b>
          </div>
        </>
      );
    }
    return (
      <GalleryStreetView
        gmapKey={gmapKey}
        isLoaded={isLoaded}
        coordinates={coordinates}
        style={{ width: '100%', height: '100%' }}
      />
    );
  }
  const renderView = (view) => {
    switch (selectedCTA) {
      case "STREET_VIEW":
        return renderGalleryView();
      case "MAP_VIEW":
        return renderMapView();
      case "TOUR":
        return <VideoVirtualTour
          videoData={pdpInitData?.propertyDetails?.virtualTourDetailsList}
        />
      // return renderGoogleMaps();
      default:
        return renderGallery();

    }
  }

  const getGirdImageSize = (index) => {
    const screenWidth = window.innerWidth;

    // Mobile: < 768px, Tablet: 768-1024px, Desktop: > 1024px, Large: > 1600px
    const getResponsiveSize = (mobileW, mobileH, tabletW, tabletH, desktopW, desktopH, largeW, largeH) => {
      if (screenWidth < 768) {
        return `w=${mobileW}&h=${mobileH}&fit=crop&auto=format`;
      } else if (screenWidth < 1024) {
        return `w=${tabletW}&h=${tabletH}&fit=crop&auto=format`;
      } else if (screenWidth < 1600) {
        return `w=${desktopW}&h=${desktopH}&fit=crop&auto=format`;
      }
      return `w=${largeW}&h=${largeH}&fit=crop&auto=format`;
    };

    switch (index) {
      case 1:
        return getResponsiveSize(180, 180, 200, 200, 220, 220, 220, 310);

      case 2:
        const isTwo = updatedImageArr().length === 2;
        return isTwo
          ? getResponsiveSize(300, 150, 400, 180, 450, 220, 450, 310)
          : getResponsiveSize(180, 180, 200, 200, 220, 220, 220, 310);

      case 3:
        return getResponsiveSize(300, 150, 400, 180, 450, 220, 450, 310);

      default:
        return getResponsiveSize(180, 180, 200, 200, 220, 220, 220, 310);
    }
  }

  const getDestination = () => {
    const add = `${streetNumber}, ${streetName},${city}, ${state} ${zip}`;
    return add;
  }


  // const renderGoogleMaps = () => {
  //   const googleMapsUrl = `https://www.google.com/maps/dir//${encodeURIComponent(getDestination())}`;
  //   window.open(googleMapsUrl, '_blank');
  // }
  //   useEffect(() => {
  //     if (propertyToSaveFrom === 'PDP' && (userEmailId || isUserSubscribed)) {
  //       onSave();
  //       dispatch(setPropertyToSaveFrom(null));
  //     }
  //   }, [propertyToSaveFrom, isUserSubscribed, userEmailId]);

  const onSave = async () => {
    const propertyId = pdpInitData?.propertyDetails?.propertyId;
    if (userEmailId || isUserSubscribed) {
      setShowModal(false)

      if (savePropertyState) {
        // dispatch(updateSaveProperty("N"));
        setSavePropertyState(false)

        trackButtonClick({
          eventName: "favourite_property_unsave_click",
          eventCategory: "NEW-PDP",
          eventSource: "pdp_gallery",
          eventLabel: `Property Id: ${
            pdpInitData?.propertyDetails?.propertyId
          }|propertyStatus: ${
            pdpInitData?.propertyDetails?.commonAttributes?.status || "N/A"
          }`,
        });

        const response = await onUnsavePress({ propertyId });
        if (response === "success") {
          dispatch(setIsAddedToSaved());

          trackApiCall({
            eventName: "favourite_property_unsaved",
            eventCategory: "NEW-PDP",
            eventSource: "pdp_gallery",
            eventLabel: `Property Id: ${propertyId}`,
          });
        } else {
          trackApiCall({
            eventName: "favourite_property_unsave_error",
            eventCategory: "Error",
            eventSource: `Error - ${
              response?.message || "Data Initialization Failed"
            }`,
            eventLabel: `Property Id: ${propertyId}`,
          });
        }
      } else {
        // dispatch(updateSaveProperty("Y"));
        setSavePropertyState(true);

        trackButtonClick({
          eventName: "favourite_property_save_click",
          eventCategory: "NEW-PDP",
          eventSource: "pdp_gallery",
          eventLabel: `Property Id: ${propertyId}`,
        });

        const response = await onSavePress({ propertyId });
        if (response === "success") {
          dispatch(showSavedTooltip(true));
          dispatch(setIsAddedToSaved());

          trackApiCall({
            eventName: "favourite_property_saved",
            eventCategory: "NEW-PDP",
            eventSource: "pdp_gallery",
            eventLabel: `Property Id: ${propertyId}`,
          });
        } else {
          trackApiCall({
            eventName: "favourite_property_save_error",
            eventCategory: "Error",
            eventSource: `Error - ${
              response?.message || "Data Initialization Failed"
            }`,
            eventLabel: `Property Id: ${propertyId}`,
          });
        }
      }
    } else {
      // setShowModal(true);
      setShow(false)
      setTimeout(() => {
        setShowModal(true); // Open save modal after a brief delay
      }, 300);

      // handleClose()
      //  setShow(false);
    }
  };

  const renderFullView = () => {
    return (
      <div
        className="row p0 mb25 mobile-margin-0 galleryImg"
        style={{ position: "relative", height: `${screenWidth > 1600 ? 620 : 450}px`, marginRight: 2 }}
      >
        <div
          className=""
          style={{ position: "absolute", width: "100%", zIndex: 2 }}
        >
          {selectedCTA === "GALLERY" && (
            <PropertyTags cmsKeyInfographic={cmsKeyInfographic} />
          )}
        </div>

        <div
          className="p0"
          style={{ background: "#eaeaea", borderRadius: 20, zIndex: 1 }}
        >
          {renderView(selectedCTA)}
        </div>
        <div
          className=" gallery-menu"
          style={{ position: "absolute", width: "100%", zIndex: 3 }}
        >
          {/* <div
                className=""> */}

          <button
            className="gallery-menu-button"
            onClick={() => {
              setSelectedCTA("GALLERY_VIEW");
              trackButtonClick({
                eventName: "gallery_section_images",
                eventCategory: "NEW-PDP",
                eventSource: "on image view click",
                eventLabel: `propId: ${pdpInitData?.propertyDetails?.propertyId}| listingId: ${pdpInitData?.propertyDetails?.listingId}`,
              });
            }}
          >
            <img src={galleryIcon}  alt="Gallery"/>
            <span style={{ paddingLeft: 5, paddingTop: 5 }}>Gallery</span>
          </button>

          <button
            className="gallery-menu-button"
            onClick={() => {
              setSelectedCTA("MAP_VIEW");
              trackButtonClick({
                eventName: "gallery_section_map",
                eventCategory: "NEW-PDP",
                eventSource: "on map view click",
                eventLabel: `propId: ${pdpInitData?.propertyDetails?.propertyId}| listingId: ${pdpInitData?.propertyDetails?.listingId}`,
              });
            }}
          >
            <FiMapPin color="#118BF4" size="20px" />
            <span style={{ paddingLeft: 5, paddingTop: 5 }}>Map View</span>
          </button>
          <button
            className="gallery-menu-button"
            onClick={() => {
              setSelectedCTA("STREET_VIEW");
              trackButtonClick({
                eventName: "gallery_section_street_view",
                eventCategory: "NEW-PDP",
                eventSource: "on street view click",
                eventLabel: `propId: ${pdpInitData?.propertyDetails?.propertyId}| listingId: ${pdpInitData?.propertyDetails?.listingId}`,
              });
            }}
          >
            <img src={streetIcon} alt="Street" />
            <span style={{ paddingLeft: 5, paddingTop: 5 }}>Street View</span>
          </button>

          {pdpInitData?.propertyDetails?.virtualTourDetailsList?.[0]
            .virtualTourUrl !== null && (
            <button
              className="gallery-menu-button mt20"
              onClick={() => {
                setSelectedCTA("TOUR");
                trackButtonClick({
                  eventName: "gallery_section_3d_virtual",
                  eventCategory: "NEW-PDP",
                  eventSource: "on 3D/Virtual view click",
                  eventLabel: `propid: ${pdpInitData?.propertyDetails?.propertyId}| listingId: ${pdpInitData?.propertyDetails?.listingId}`,
                });
              }}
            >
              <IoEyeOutline color="#118BF4" size="20px" />
              <span style={{ paddingLeft: 5, paddingTop: 5 }}>3D/Virtual</span>
            </button>
          )}

          {/* <button className="gallery-menu-button"
            onClick={() =>

              setSelectedCTA("TOUR")
            }>
            <TbLocation color='#118BF4' size="20px" />
            <span style={{ paddingLeft: 5, paddingTop: 5 }}>
              Get Directions
            </span>
          </button> */}

          {/* </div > */}
          {/* {
                    ImagesArr()?.length > 0 &&
                    <div className="row gallery-count">

                    <button className="gallery-count-button"
                     onClick={() =>
                        setShow(true)

                      }>
                    <RiGalleryView2   size="15px"/>

                    <span style={{paddingLeft:5, paddingTop:5}}>
                        {
                             `${selectedImgIndex}/${ImagesArr().length} Photos`
                        }
                       </span>
                    </button>

                </div >

            } */}
        </div>
        <Modal className="modal-90w" size="xl" show={show} onHide={handleClose}>
          <Modal.Header closeButton className="border-bottom-0 mt5 pr30">
            {/* <div
              className="center">
              <button className="gallery-menu-button"
                onClick={() =>
                  setSelectedCTA("GALLERY")

                }>
                <FaHeart
                  color={"#888D91"}
                  className="cursor-pointer"
                  size={18}
                  onClick={handleFavoriteToggle}
                />
                <span style={{ paddingLeft: 5, paddingTop: 5 }}>
                  Save
                </span>
              </button >
              <button className="gallery-menu-button"
                onClick={() =>
                  setSelectedCTA("MAP_VIEW")
                }>
                <IoShareSocialOutline size="15px" />
                <span style={{ paddingLeft: 5, paddingTop: 5 }}>
                  Share
                </span>
              </button>


            </div > */}
            <div className="pdp-header-right pr15">
              <div className="single_property_social_share position-static transform-none">
                <div className="spss style2 text-end tal-400">
                  <button
                    className="headerButton dropdown"
                    id="pdpSaveBtn"
                    onClick={() => {
                      trackButtonClick({
                        eventName: "lightbox_favorite_click",
                        eventParams: { action: savePropertyState ? "remove" : "add" },
                        eventCategory: "NEW-PDP",
                        eventSource: "Lightbox Save Click",
                        eventLabel: `propId: ${
                          pdpInitData?.propertyDetails?.propertyId
                        }|propertyStatus: ${
                          pdpInitData?.propertyDetails?.commonAttributes
                          ?.status || "N/A"
                        }`,
                      });
                      onSave();
                    }}
                  >
                    <img
                      src={savePropertyState ? saved : save}
                      className="nav-tab-img"
                      alt=""
                      aria-hidden="true"
                    />
                    <span> Save</span>
                  </button>

                  <button
                    className="headerButton dropdown"
                    id="dropdownMenu2"
                    onClick={() => {
                      setIsOpen(!isOpen)
                      trackButtonClick({
                        eventName: `share_click`,
                        eventCategory: "NEW-PDP",
                        eventSource: "on tab click",
                        eventLabel: `${
                          pdpInitData?.propertyDetails?.propertyId
                        }|${pdpInitData?.propertyDetails?.listingId}|${
                          pdpInitData?.propertyDetails?.address?.streetNumber
                        } ${
                          pdpInitData?.propertyDetails?.address?.streetName
                        }, ${pdpInitData?.propertyDetails?.address?.county}, ${
                          pdpInitData?.propertyDetails?.address?.state
                        }, ${pdpInitData?.propertyDetails?.address?.city}, ${
                          pdpInitData?.propertyDetails?.address?.zip
                        }|Referrer: Other|Foreclosure Property: ${
                          isForeclosure ? "Yes" : "No"
                        }|Status: ${
                          pdpInitData?.propertyDetails?.commonAttributes
                            ?.status || "N/A"
                        }`,
                      });
                    }}
                  >
                    <img src={shareImg} className="nav-tab-img" alt=""
                      aria-hidden="true" />{" "}
                    Share
                    <div
                      className={`dropdown-menu shareDropDown ${
                        isOpen ? "show" : ""
                      }`}
                      aria-labelledby="dropdownMenu2"
                    >
                      <div>
                        <EmailShareButton
                          body={emailBody}
                          subject={`Hubzu.com ${address?.streetNumber} ${address?.streetName} ${address?.city} ${address?.state} ${address?.zip}`}
                          url={window.location.href}
                          aria-label="Email"
                        >
                          <EmailIcon size={32} round={true}></EmailIcon>
                        </EmailShareButton>
                      </div>
                      <div>
                        <FacebookShareButton
                          url={window.location.href}
                          aria-label="Facebook"
                        >
                          <FacebookIcon size={32} round={true} />
                        </FacebookShareButton>
                      </div>
                      <div
                        aria-label='Instagram'
                        onClick={() => {
                          window.open('https://www.instagram.com/hubzu_official', '_blank', 'left=20,top=20,width=600,height=500,toolbar=1,resizable=0');
                        }}
                        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '32px', height: '32px', borderRadius: '50%', background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)' }}
                      >
                        <FaInstagram size={18} color='white' />
                      </div>
                      <div>
                        <LinkedinShareButton
                          url={window.location.href}
                          aria-label="LinkedIn"
                        >
                          <LinkedinIcon size={32} round={true}></LinkedinIcon>
                        </LinkedinShareButton>
                      </div>
                      <div
                        aria-label="Pinterest"
                        onClick={() => {
                          window.open(
                            `//www.pinterest.com/pinthis/?url=${window.location.href}`,
                            "mywin",
                            "left=20,top=20,width=600,height=500,toolbar=1,resizable=0"
                          );
                        }}
                      >
                        <PinterestIcon size={32} round={true}></PinterestIcon>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            {/* <Row className="galleryContainer">
            <Col xl={8} md={12} xs={12} className='galleryLeft'>
            <PDPGallery
              galleryID="my-test-gallery"
              images={ImagesArr()}
              galleryIndex={galleryIndex}
              setGalleryIndex={setGalleryIndex}
         ></PDPGallery>
            </Col>
            <Col xl={4} xs={6} md={4} className='galleryRight'>
            <GalleryBidCenter
                  statusPayload={statusPayload}
                  pdpBidCenter={cmsData?.pdpBidCenter}
                  listingType={listingType}
                  status={status}
                  offerType={offerType}
                  offerCenterDetail={offerCenterDetail}
                  isSignedUser={user_info !== null ? true : false}
                  isFcOnlineFlag={pdpInitData?.fcOnlineFlag}
                  pdpData={pdpInitData}
                  financialType={financialType}
                  pdpPropertyFees={pdpPropertyFees}
                  isWatchProperty={isWatchProperty}
                  fullAddress={fullAddress}
                  showAlert={showAlert}
                  setShowAlert={setShowAlert}
                  alertText={alertText}
                  setAlertText={setAlertText}
                />
            </Col>


         </Row> */}

            <div className="galleryContainer row">
              <div className="galleryLeft col-xs-12 col-sm-12 col-lg-6 pl0 pr25">
                <PDPGallery
                  galleryID="my-test-gallery"
                  images={ImagesArr()}
                  galleryIndex={galleryIndex}
                  setGalleryIndex={setGalleryIndex}
                  cmsKeyInfographic={cmsKeyInfographic}
                ></PDPGallery>
              </div>
              <div className="galleryRight col-xs-12 col-sm-12 col-lg-6">
                <GalleryBidCenter
                  statusPayload={statusPayload}
                  pdpBidCenter={cmsData?.pdpBidCenter}
                  listingType={listingType}
                  status={status}
                  offerType={offerType}
                  offerCenterDetail={offerCenterDetail}
                  isSignedUser={user_info !== null ? true : false}
                  isFcOnlineFlag={pdpInitData?.fcOnlineFlag}
                  pdpData={pdpInitData}
                  financialType={financialType}
                  pdpPropertyFees={pdpPropertyFees}
                  isWatchProperty={isWatchProperty}
                  fullAddress={fullAddressForm}
                  handleClose={handleClose}
                  setSavePropertyState={setSavePropertyState}
                  savePropertyState={savePropertyState}
                  showAlert={showAlert}
                  setShowAlert={setShowAlert}
                  alertText={alertText}
                  setAlertText={setAlertText}
                />
              </div>
            </div>
          </Modal.Body>
        </Modal>
        {showModal && (
          <Modal show={showModal} onHide={() => setShowModal(false)}>
            <PDPSaveModal
              showModal={showModal}
              setShowModal={setShowModal}
              isHideArrow={true}
            />
          </Modal>
        )}
      </div>
    );


  }


  const renderHalfView = () => {
    return (
      <div className='row p0 mb25 prm20 mobile-margin-0'>
        <div className="application_statics p0 mobile-margin-0 tab-width galleryImg"
          style={{ width: "50%", position: "relative"}} >
          <div
            className=""
            style={{ position: "absolute", width: "100%", zIndex: 2 }}>
            {selectedCTA === 'GALLERY' && <PropertyTags cmsKeyInfographic={cmsKeyInfographic} />}
          </div>

          <div style={{ zIndex: 1, height: '100%', width: '100%' }}>
            {

              renderView(selectedCTA)
            }
          </div>

          <div className='pl-3 gallery-menu' style={{ position: "absolute", width: "100%", zIndex: 3 }}>
            {/* <div
                className=""> */}
              <button className="gallery-menu-button ml-3"
              onClick={() => {
                setSelectedCTA("GALLERY_VIEW")
                trackButtonClick({
                eventName: "gallery_section_images",
                eventCategory: "NEW-PDP",
                eventSource: "on image view click",
                eventLabel: `propId: ${pdpInitData?.propertyDetails?.propertyId}| listingId: ${pdpInitData?.propertyDetails?.listingId}`,
              });
              }
              }>
              <img src={galleryIcon} alt="Gallery"/>
              <span style={{ paddingLeft: 5, paddingTop: 5 }}>
                Gallery
              </span>
            </button>
            <button className="gallery-menu-button"
              onClick={() => {
                setSelectedCTA("MAP_VIEW")
                trackButtonClick({
                  eventName: "gallery_section_map",
                  eventCategory: "NEW-PDP",
                  eventSource: "on map view click",
                  eventLabel: `propId: ${pdpInitData?.propertyDetails?.propertyId}| listingId: ${pdpInitData?.propertyDetails?.listingId}`,
                });
              }
              }>
              <FiMapPin color='#118BF4' size="20px" />
              <span style={{ paddingLeft: 5, paddingTop: 5 }}>
                Map View
              </span>
            </button >
            <button className="gallery-menu-button "
              onClick={() => {
                setSelectedCTA("STREET_VIEW")
                trackButtonClick({
                  eventName: "gallery_section_street_view",
                  eventCategory: "NEW-PDP",
                  eventSource: "on street view click",
                  eventLabel: `propId: ${pdpInitData?.propertyDetails?.propertyId}| listingId: ${pdpInitData?.propertyDetails?.listingId}`,
                });
              }
              }>
              <img src={streetIcon} alt="Street"/>
              <span style={{ paddingLeft: 5, paddingTop: 5 }}>
                Street View
              </span>
            </button>

           {pdpInitData?.propertyDetails?.virtualTourDetailsList?.[0].virtualTourUrl !== null &&
            <button className="gallery-menu-button mt20"
              onClick={() => {
                setSelectedCTA("TOUR")
                trackButtonClick({
                  eventName: "gallery_section_3d_virtual",
                  eventCategory: "NEW-PDP",
                  eventSource: "on 3D/Virtual view click",
                  eventLabel: `propid: ${pdpInitData?.propertyDetails?.propertyId}| listingId: ${pdpInitData?.propertyDetails?.listingId}`,
                });
              }
              }>
              <IoEyeOutline color='#118BF4' size="20px" />
              <span style={{ paddingLeft: 5, paddingTop: 5 }}>
                3D/Virtual
              </span>
            </button>
          }





            {/* <button className="gallery-menu-button"
              onClick={() =>

                setSelectedCTA("TOUR")
              }>
              <TbLocation color='#118BF4' size="20px" />
              <span style={{ paddingLeft: 5, paddingTop: 5 }}>
                Get Directions
              </span>
            </button> */}


          </div >
          <Modal className="modal-90w" size="xl" show={show} onHide={handleClose}>
            <Modal.Header closeButton className='border-bottom-0 mt5 pr30'>
              {/* <div
                className="center">
                <button className="gallery-menu-button"
                  onClick={() =>
                    setSelectedCTA("GALLERY")

                  }>
                  <FaHeart
                    color={"#888D91"}
                    className="cursor-pointer"
                    size={18}
                    onClick={handleFavoriteToggle}
                  />
                  <span style={{ paddingLeft: 5, paddingTop: 5 }}>
                    Save
                  </span>
                </button >
                <button className="gallery-menu-button"
                  onClick={() =>
                    setSelectedCTA("MAP_VIEW")
                  }>
                  <IoShareSocialOutline size="15px" />
                  <span style={{ paddingLeft: 5, paddingTop: 5 }}>
                    Share
                  </span>
                </button>


              </div > */}
                <div className="pdp-header-right pr15">
                    <div className="single_property_social_share position-static transform-none">
                      <div className="spss style2 text-end tal-400">
                        <button className="headerButton dropdown" id="pdpSaveBtn" onClick={onSave}>
                          <img src={savePropertyState? saved : save} className="nav-tab-img" alt="" aria-hidden="true" />
                          <span>{" "}Save</span>
                        </button>

                    <button className="headerButton dropdown" id="dropdownMenu2" onClick={() => setIsOpen(!isOpen)}>
                      <img src={shareImg} className="nav-tab-img" alt="" aria-hidden="true" />
                      {" "}Share
                      <div className={`dropdown-menu shareDropDown ${isOpen ? 'show' : ''}`} aria-labelledby="dropdownMenu2">
                        <div>
                          <EmailShareButton
                            body={emailBody}
                            subject={`Hubzu.com ${address?.streetNumber} ${address?.streetName} ${address?.city} ${address?.state} ${address?.zip}`}
                            url={window.location.href}
                            aria-label='Email'
                          >
                            <EmailIcon size={32} round={true}></EmailIcon>
                          </EmailShareButton>
                        </div>
                        <div>
                          <FacebookShareButton url={window.location.href} aria-label='Facebook'>
                            <FacebookIcon size={32} round={true} />
                          </FacebookShareButton>
                        </div>
                        <div
                          aria-label='Instagram'
                          onClick={() => {
                            window.open('https://www.instagram.com/hubzu_official', '_blank', 'left=20,top=20,width=600,height=500,toolbar=1,resizable=0');
                          }}
                          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '32px', height: '32px', borderRadius: '50%', background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)' }}
                        >
                          <FaInstagram size={18} color='white' />
                        </div>
                        <div>
                          <LinkedinShareButton url={window.location.href} aria-label='LinkedIn'>
                            <LinkedinIcon size={32} round={true}></LinkedinIcon>
                          </LinkedinShareButton>
                        </div>
                        <div
                          aria-label='Pinterest'
                          onClick={() => {
                            window.open(`//www.pinterest.com/pinthis/?url=${window.location.href}`, 'mywin', 'left=20,top=20,width=600,height=500,toolbar=1,resizable=0');
                          }}>
                          <PinterestIcon size={32} round={true}></PinterestIcon>
                        </div>
                      </div>
                    </button>

                  </div>
                </div>
              </div>

            </Modal.Header>
            <Modal.Body>
              <div className="galleryContainer row">
                <div className="galleryLeft col-xs-12 col-sm-12 col-md-7 p0 pr25">
                  <PDPGallery
                    modal
                    galleryID="my-test-gallery"
                    images={ImagesArr()}
                    galleryIndex={galleryIndex}
                    setGalleryIndex={setGalleryIndex}
                    cmsKeyInfographic={cmsKeyInfographic}
                  ></PDPGallery>
                </div>
                <div className="galleryRight col-xs-12 col-sm-12 col-md-5">
                  <GalleryBidCenter
                    statusPayload={statusPayload}
                    pdpBidCenter={cmsData?.pdpBidCenter}
                    listingType={listingType}
                    status={status}
                    offerType={offerType}
                    offerCenterDetail={offerCenterDetail}
                    isSignedUser={user_info !== null ? true : false}
                    isFcOnlineFlag={pdpInitData?.fcOnlineFlag}
                    pdpData={pdpInitData}
                    financialType={financialType}
                    pdpPropertyFees={pdpPropertyFees}
                    isWatchProperty={isWatchProperty}
                    fullAddress={fullAddressForm}
                    handleClose={handleClose}
                    savePropertyState={savePropertyState}
                    setSavePropertyState={setSavePropertyState}
                    showAlert={showAlert}
                    setShowAlert={setShowAlert}
                    alertText={alertText}
                    setAlertText={setAlertText}
                  />
                </div>
              </div>

            </Modal.Body>
          </Modal>
          {showModal &&
            <Modal show={showModal} onHide={() => setShowModal(false)}  >
              <PDPSaveModal showModal={showModal} setShowModal={setShowModal} isHideArrow={true} />

            </Modal>
          }
        </div>
        <div className="d-none d-lg-block galleryImg"
          style={{ width: "50%", position: "relative"}} >

          {updatedImageArr().length === 1 ?
            <ImageSingle imageUrl={updatedImageArr()[0]?.largeURL} style={{ backgroundSize: 'cover', width: '100%', height: '100%', borderRadius: 10 }} onClick={renderGalleryPopUp} isPDP={true}  />


            :


            <ImageList className='galleryImg' sx={{ overflow: 'hidden' }} cols={2} rowHeight={window.innerWidth > 1600 ? 300 : 220}  gap={12} >
              {gridArr().map((item, index) => (


                <ImageListItem
                  key={item.img}
                  cols={(updatedImageArr().length === 2 && index === 2) ? 2 : 1} // Make the 3rd image span 2 columns (rectangle)
                  rows={1}
                  style={{ textAlign:'center'}}


                >
                  {index === 3 ?
                    updatedImageArr().length > 4 ?
                      <>

                        <img className="" style={{
                          borderRadius: 15, flex: 1,
                          width: '100%',
                          height: '100%',
                          resizeMode: 'contain',

                        }}
                          alt="gallery"
                          src={`${item.largeURL}?${getGirdImageSize(index)}`}
                          loading="lazy" onClick={renderGalleryPopUp} />
                        <div className="gallery-count"
                        >
                          <button className="gallery-count-button"

                            onClick={() =>
                              setShow(true)

                            }>
                            <RiGalleryView2 size="15px" />

                            <span style={{ paddingLeft: 5, paddingTop: 5 }}>
                              {
                                `See all Photos (${ImagesArr().length})`
                              }
                            </span>
                          </button>

                        </div >

                      </>
                      :
                      <img style={{
                        borderRadius: 15, flex: 1,
                        width: '100%',
                        height: '100%',
                        resizeMode: 'contain'
                      }}
                        alt="photos"
                        src={`${item.largeURL}?${getGirdImageSize(index)}`}
                        loading="lazy"
                        onClick={renderGalleryPopUp}
                      />


                    :
                    <img style={{
                      borderRadius: 15, flex: 1,
                      width: '100%',
                      height: '100%',
                      resizeMode: 'contain'
                    }}
                      alt="photos"
                      src={`${item.largeURL}?${getGirdImageSize(index)}`}
                      loading="lazy"
                      onClick={renderGalleryPopUp}
                    />
                  }
                  {/* <img
        style={{
          borderRadius: 15,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
        alt="gallery"
        src={`${item.largeURL}?${getGirdImageSize(index)}`}
        loading="lazy"
      /> */}
                </ImageListItem>
              ))}
            </ImageList>

          }

        </div>

      </div>
    )
  }
  return (
    <>
    {ImagesArr()?.length > 1 ?
      renderHalfView()
      : renderFullView()}
      <BidAlertTextModal showAlert={showAlert} onClose={()=>setShowAlert(false)} alertText={alertText} />
    </>
  );


};

export default memo(GalleryHeader);

